import { event, GtagEvent } from "./event";

export interface SignUp extends GtagEvent {
    method?:string;
}
export const sign_up = ($_?:SignUp) => event('sign_up',$_);